<template>
    <section id="vue-slot" class="vue-slot-component page-section">
        <div class="container">
            <p>First question: what result we will get if add child component with some content between brackets?</p>
            <button v-if="!isChildBracketsCodeOpen" @click="isChildBracketsCodeOpen = !isChildBracketsCodeOpen">Show
                code
            </button>
            <button v-if="isChildBracketsCodeOpen" @click="isChildBracketsCodeOpen = !isChildBracketsCodeOpen">Hide
                code
            </button>
            <div v-show="isChildBracketsCodeOpen" class="code-container">
                <div>Parent component</div>
                <pre class="language-markup">
                      <code>
                          &lt;template&gt;
                            &lt;div id="parentComponent" &gt;
                                &lt;div&gt;
                                    Hello from Parent Component
                                &lt;/div&gt;
                                &lt;ChildComponent&gt;
                                    Hello!!!
                                &lt;/ChildComponent&gt;
                            &lt;/div&gt;
                          &lt;/template&gt;
                          ...
                      </code>
                </pre>

                <div>Child component</div>
                <pre class="language-markup">
                      <code>
                          &lt;template&gt;
                            &lt;div id="childComponent" &gt;
                                &lt;div&gt;
                                    Hello from Child Component
                                &lt;/div&gt;
                            &lt;/div&gt;
                          &lt;/template&gt;
                          ...
                      </code>
                </pre>

                <div>Result</div>
                <pre class="language-markup">
                      <code>
                          Hello from Parent Component
                          Hello from Child Component
                      </code>
                </pre>
            </div>

            <p>From result we can see, that we can't use content between Child Component brackets.</p>
            <p>So, how we can change Child Component content from Parent Component? One of the options: with <span
                class="bold">slots</span></p>

            <br>
            <p>Now we check how to use slots:</p>
            <button v-if="!isSlotsBaseCodeExampleOpen"
                    @click="isSlotsBaseCodeExampleOpen = !isSlotsBaseCodeExampleOpen">Show
                code
            </button>
            <button v-if="isSlotsBaseCodeExampleOpen" @click="isSlotsBaseCodeExampleOpen = !isSlotsBaseCodeExampleOpen">
                Hide
                code
            </button>
            <div v-show="isSlotsBaseCodeExampleOpen" class="code-container">
                <div>Parent component</div>
                <pre class="language-markup">
                      <code>
                          &lt;template&gt;
                            &lt;div id="parentComponent" &gt;
                                &lt;div&gt;
                                    Hello from Parent Component
                                &lt;/div&gt;
                                &lt;ChildComponent&gt;
                                    Hello!!!
                                &lt;/ChildComponent&gt;
                            &lt;/div&gt;
                          &lt;/template&gt;
                          ...
                      </code>
                </pre>

                <div>Child component</div>
                <pre class="language-markup">
                      <code>
                          &lt;template&gt;
                            &lt;div id="childComponent" &gt;

                                &lt;slot /&gt;

                                &lt;div&gt;
                                    Hello from Child Component
                                &lt;/div&gt;
                            &lt;/div&gt;
                          &lt;/template&gt;
                          ...
                      </code>
                </pre>

                <div>Result</div>
                <pre class="language-markup">
                      <code>
                          Hello from Parent Component
                          Hello!!!
                          Hello from Child Component
                      </code>
                </pre>
            </div>

            <p>Need to understand that code for slot from Parent Component will render in Child Component.</p>

            <br>
            <p>Another question: can we use function in Parent Component in code for slot?</p>
            <p>For example:</p>
            <button v-if="!isParentFunctionInSlotCodeOpen"
                    @click="isParentFunctionInSlotCodeOpen = !isParentFunctionInSlotCodeOpen">Show
                code
            </button>
            <button v-if="isParentFunctionInSlotCodeOpen"
                    @click="isParentFunctionInSlotCodeOpen = !isParentFunctionInSlotCodeOpen">Hide
                code
            </button>
            <div v-show="isParentFunctionInSlotCodeOpen" class="code-container">
                <div>Parent component</div>
                <pre class="language-markup">
                      <code>
                          &lt;template&gt;
                            &lt;div id="parentComponent" &gt;
                                &lt;div&gt;
                                    Hello from Parent Component
                                &lt;/div&gt;
                                &lt;ChildComponent&gt;
                                    &lt;div @click="pressed()"&gt;
                                        Hello!!!
                                    &lt;/div&gt;
                                &lt;/ChildComponent&gt;
                            &lt;/div&gt;
                          &lt;/template&gt;
                          ...
                          methods: {
                            pressed(){
                                alert('Pressed function from Parent Component')
                                }
                          },
                      </code>
                </pre>

                <div>Child component</div>
                <pre class="language-markup">
                      <code>
                          &lt;template&gt;
                            &lt;div id="childComponent" &gt;

                                &lt;slot&gt;
                                    &lt;div @click="pressed()"&gt;
                                        Hello from slot
                                    &lt;/div&gt;
                                &lt;/slot&gt;

                                &lt;div&gt;
                                    Hello from Child Component
                                &lt;/div&gt;
                            &lt;/div&gt;
                          &lt;/template&gt;
                          ...
                          methods: {
                            pressed(){
                                alert('Pressed function from Child Component')
                                }
                          },
                      </code>
                </pre>

                <div>Output</div>
                <pre class="language-markup">
                      <code>
                            Hello from Parent Component
                            Hello!!!
                            Hello from Child Component
                      </code>
                </pre>

                <div>Result after click to element</div>
                <pre class="language-markup">
                      <code>
                          Pressed function from Parent Component
                      </code>
                </pre>
            </div>

            <p>Anything inside <span class="bold">&lt;ChildComponent&gt; &lt;/ChildComponent&gt;</span> for the slot
                uses Parent Component. So this is ParentComponent <span class="bold">scope</span>.</p>

            <br>
            <p>Now we can create something interesting, for example list with names.</p>
            <p>Create Parent Component with Child Component. By default in Child Component we have loop with names by
                format first name and last name, but from Parent Component we change it to loop with format only first
                name.</p>
            <p>In code we can see named slot 'namesList'. Now we send from Child Component to Parent Component props,
                functions and use them.</p>
            <button v-if="!isSlotsCodeExampleOpen" @click="isSlotsCodeExampleOpen = !isSlotsCodeExampleOpen">Show
                code
            </button>
            <button v-if="isSlotsCodeExampleOpen" @click="isSlotsCodeExampleOpen = !isSlotsCodeExampleOpen">Hide
                code
            </button>
            <div v-show="isSlotsCodeExampleOpen" class="code-container">
                <div>Parent component</div>
                <pre class="language-markup">
                        <code>
                          &lt;template&gt;
                            &lt;div id="parentComponent" &gt;
                                &lt;ChildComponent&gt;
                                   &lt;template #namesList="slotProps"&gt;
                                        &lt;div @click="slotProps.alertName(slotProps.firstName)"&gt;
                                            { { slotProps.firstName } }
                                        &lt;/div&gt;
                                    &lt;/template&gt;
                                &lt;/ChildComponent&gt;
                            &lt;/div&gt;
                          &lt;/template&gt;
                          ...
                          methods: {}
                      </code>
                    </pre>

                <div>Child component</div>
                <pre class="language-markup">
                    <code>
                        &lt;template&gt;
                            &lt;div id="childComponent" &gt;
                                &lt;div v-for="(one, index) in names" :key="index"&gt;
                                    &lt;slot name="namesList" :firstName="one.firstName" :lastName="one.lastName" :alertName="alertName"&gt;
                                        &lt;div @click=alertName(one.lastName)&gt;
                                            { {one.firstName + ' ' + one.lastName} }
                                        &lt;/div&gt;
                                    &lt;/slot&gt;
                                &lt;/div&gt;
                            &lt;/div&gt;
                        &lt;/template&gt;
                        ...
                        methods:{
                            alertName(name) {
                                alert(name)
                            },
                        },
                        data() {
                            return {
                                names: {
                                    'id_1': {
                                        id: 'id_1',
                                        firstName: 'Name_1',
                                        lastName: 'Last_name_1',
                                        information: 'some information about Name_1'
                                    },
                                    'id_2': {
                                        id: 'id_2',
                                        firstName: 'Name_2',
                                        lastName: 'Last_name_2',
                                        information: 'some information about Name_2'
                                    },
                                }
                            }
                        }
                    </code>
                </pre>
            </div>

            <list-component>
                <template #namesList="slotProps">
                    <div @click="slotProps.alertName(slotProps.firstName)">{{ slotProps.firstName }}</div>
                </template>
            </list-component>


        </div>
    </section>
</template>

<script>
import ListComponent from "@/components/codingProjects/vue-slots/ListComponent.vue";

export default {
    name: "VueScopeComponent",
    components: {ListComponent},
    data() {
        return {
            isChildBracketsCodeOpen: false,
            isSlotsBaseCodeExampleOpen: false,
            isSlotsCodeExampleOpen: false,
            isParentFunctionInSlotCodeOpen: false,

        }
    },
    methods: {
        pressed() {
            alert('Pressed function from Parent Component')
        }
    },
    created() {

    },
}
</script>

<style lang="scss" scoped>
#vue-slot.vue-slot-component {
    background-color: #ffffff;
    width: 100%;

    .bold {
        font-weight: bold;
    }

    button {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        width: 95px;
        margin: 15px 0;
        cursor: pointer;
        padding: 0;
    }

    .container {
        .description {
            max-width: 900px;
        }

        .code-container {
            margin: 15px;
            padding: 10px;
            box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
        }
    }
}

</style>